import { render, staticRenderFns } from "./app-explain-desc.vue?vue&type=template&id=72eecec8&scoped=true&"
import script from "./app-explain-desc.vue?vue&type=script&lang=js&"
export * from "./app-explain-desc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72eecec8",
  null
  
)

export default component.exports